window.onload = function() {
	var w = document.body.offsetWidth;
	var size = w/18;
  document.getElementsByTagName('html')[0].style.fontSize = size+ 'px';
  window.onresize = function(){
    var w = document.body.offsetWidth;
    var size = w/18;
    document.getElementsByTagName('html')[0].style.fontSize = size+ 'px';
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/reset.js